const buildings = [
  {
    id: 'floors',
    source: 'buildingsSource',
    type: 'fill-extrusion',
    filter: ['!=', 'building_id', ''],
    interactive: false,
    paint: {
      'fill-extrusion-color': {
        base: 1,
        type: 'exponential',
        property: 'level',
        stops: [
          [0, 'hsl(47, 43%, 55%)'],
          [1, 'hsl(48, 45%, 62%)'],
          [2, 'hsl(48, 49%, 69%)'],
          [3, 'hsl(47, 55%, 76%)'],
          [4, 'hsl(49, 64%, 84%)'],
          [5, 'hsl(49, 64%, 84%)'],
        ],
      },
      'fill-extrusion-opacity': 1,
      'fill-extrusion-height': {
        base: 1,
        type: 'exponential',
        property: 'height',
        stops: [[0, 0], [100, 100]],
      },
      'fill-extrusion-base': {
        base: 1,
        type: 'exponential',
        property: 'min_height',
        stops: [[0, 0], [100, 100]],
      },
    },
  },
  {
    id: 'floors_current',
    source: 'buildingsSource',
    type: 'fill-extrusion',
    filter: ['all', ['==', 'building_id', ''], ['<=', 'level', 999]],
    paint: {
      'fill-extrusion-color': {
        base: 1,
        type: 'exponential',
        property: 'level',
        stops: [
          [0, 'hsl(208, 38%, 52%)'],
          [1, 'hsl(208, 42%, 59%)'],
          [2, 'hsl(207, 47%, 66%)'],
          [3, 'hsl(206, 55%, 73%)'],
          [4, 'hsl(204, 70%, 79%)'],
          [5, 'hsl(201, 97%, 86%)'],
        ],
      },
      'fill-extrusion-opacity': 1,
      'fill-extrusion-height': {
        base: 1,
        type: 'exponential',
        property: 'height',
        stops: [[0, 0], [100, 100]],
      },
      'fill-extrusion-base': {
        base: 1,
        type: 'exponential',
        property: 'min_height',
        stops: [[0, 0], [100, 100]],
      },
    },
  },
  {
    id: 'floors_current_dimmed',
    source: 'buildingsSource',
    type: 'fill-extrusion',
    filter: ['all', ['==', 'building_id', ''], ['>', 'level', 999]],
    paint: {
      'fill-extrusion-color': {
        base: 1,
        type: 'exponential',
        property: 'level',
        stops: [
          [0, 'hsl(208, 38%, 52%)'],
          [1, 'hsl(208, 42%, 59%)'],
          [2, 'hsl(207, 47%, 66%)'],
          [3, 'hsl(206, 55%, 73%)'],
          [4, 'hsl(204, 70%, 79%)'],
          [5, 'hsl(201, 97%, 86%)'],
        ],
      },
      'fill-extrusion-opacity': 0.3,
      'fill-extrusion-height': {
        base: 1,
        type: 'exponential',
        property: 'height',
        stops: [[0, 0], [100, 100]],
      },
      'fill-extrusion-base': {
        base: 1,
        type: 'exponential',
        property: 'min_height',
        stops: [[0, 0], [100, 100]],
      },
    },
  },
  {
    id: 'floors_highlight',
    source: 'buildingsSource',
    type: 'fill-extrusion',
    filter: ['==', 'building_id', ''],
    paint: {
      'fill-extrusion-color': {
        base: 1,
        type: 'exponential',
        property: 'level',
        stops: [
          [0, 'hsl(208, 38%, 52%)'],
          [1, 'hsl(208, 42%, 59%)'],
          [2, 'hsl(207, 47%, 66%)'],
          [3, 'hsl(206, 55%, 73%)'],
          [4, 'hsl(204, 70%, 79%)'],
          [5, 'hsl(201, 97%, 86%)'],
        ],
      },
      'fill-extrusion-height': {
        base: 1,
        type: 'exponential',
        property: 'height',
        stops: [[0, 0], [100, 100]],
      },
      'fill-extrusion-base': {
        base: 1,
        type: 'exponential',
        property: 'min_height',
        stops: [[0, 0], [100, 100]],
      },
    },
  },
];

export default buildings;
